import { useSyncExternalStore } from "react";
import { i18n } from "./macro-runtime";

// Lingui merges catalogs in place, and a catalog can arrive after its locale is active.
// Track every change on the shared singleton, including changes between render and subscribe.
let revision = 0;
i18n.on("change", () => {
  revision += 1;
});

const subscribe = (listener: () => void) => i18n.on("change", listener);
const getRevision = () => revision;

/** Subscribe components outside LocaleGate to locale and catalog changes, without loading either. */
export function useI18nLocale(): string {
  useSyncExternalStore(subscribe, getRevision, getRevision);
  return i18n.locale;
}
